"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme = {
    siteVariables: {
        brandIcon: '/images/icons/teams-96x96.png',
    },
};
exports.default = theme;
